export const rowsSx = {
    padding: '4.5px',
    alignItems: 'center'
}

export const fieldset = {
    width: "100%",
    padding: '10px',
    borderRadius: '10px',
    flexWrap: 'wrap'
}
